import script from "./date-edit.vue?vue&type=script&setup=true&lang=ts"
export * from "./date-edit.vue?vue&type=script&setup=true&lang=ts"

import "./date-edit.vue?vue&type=style&index=0&id=2d7b5a49&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d7b5a49"]])

export default __exports__